<template>
  <div class="custom-navbar">
    <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top">
      <div class="container-fluid">
        <router-link class="router-logo" to="/">
          <img
            alt="Vue logo"
            class="logo"
            src="../assets/MultiserviciosGMM.png"
          />
        </router-link>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <router-link class="nav-link" to="/about">About</router-link>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Dropdown
              </a>
              <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                <li><router-link class="nav-link" to="/addService">Agregar</router-link></li>
                <li><router-link class="nav-link" to="/services">Servicios</router-link></li>
                <li><hr class="dropdown-divider" /></li>
                <li>
                  <a class="dropdown-item" href="#">Something else here</a>
                </li>
              </ul>
            </li>
          </ul>
          <div class="d-flex gap-2">
            <img alt="User Icon" class="ico" src="../assets/logo.png" />
            <template v-if="usuario">
              <div class="dropdown">
                <a href="#" class="dropdown-toggle" data-bs-toggle="dropdown">
                  {{ usuario.nombreCompleto }}
                </a>
                <ul class="dropdown-menu">
                  <li><router-link class="dropdown-item" :to="{name: 'MiPerfil'}">Mi Perfil</router-link></li>
                  <li v-if="usuario && (usuario.categoria === 'Administrador' || usuario.categoria === 'Director')"><router-link class="dropdown-item" :to="{name: 'AdminUsuarios'}">Administrar Usuarios</router-link></li>
                  <li><hr class="dropdown-divider" /></li>
                  <li><a class="dropdown-item" href="#" @click.prevent="cerrarSesion">Cerrar Sesión</a></li>
                </ul>
              </div>
            </template>
            <template v-else>
              <button
                class="btn btn-outline-success btn-sm"
                type="button"
                @click.prevent="$router.push({ name: 'Login' })"
              >
                Iniciar Sesión
              </button>
              <button
                class="btn btn-outline-success btn-sm"
                type="button"
                @click.prevent="$router.push({ name: 'RegistroUsuario' })"
              >
                Registro
              </button>
            </template>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      usuario: null
    };
  },
  created() {
    // Verificar si hay un usuario en localStorage al cargar el componente
    this.verificarUsuario();
    // Escuchar eventos de inicio y cierre de sesión
    window.addEventListener('storage', this.verificarUsuario);
+   // Escuchar evento local cuando cambia el usuario en esta pestaña
+   window.addEventListener('usuario-cambiado', this.verificarUsuario);
  },
  beforeUnmount() {
    // Eliminar el listener al desmontar el componente
-   window.removeEventListener('storage', this.verificarUsuario);
+   window.removeEventListener('storage', this.verificarUsuario);
+   window.removeEventListener('usuario-cambiado', this.verificarUsuario);
  },
  methods: {
    verificarUsuario() {
      const usuarioGuardado = localStorage.getItem('usuario');
      if (usuarioGuardado) {
        try {
          this.usuario = JSON.parse(usuarioGuardado);
        } catch (e) {
          this.usuario = null;
          localStorage.removeItem('usuario');
        }
      } else {
        this.usuario = null;
      }
    },
    cerrarSesion() {
      localStorage.removeItem('usuario');
      this.usuario = null;
+     // Notificar cambios para que otros componentes actualicen su estado
+     window.dispatchEvent(new Event('usuario-cambiado'));
      this.$router.push({ name: 'home' });
    }
  }
};
</script>

<style scoped>
nav {
  box-shadow: 1px 3px 5px rgba(0, 0, 0, 0.1);
}
.logo {
  height: 60px;
  pointer-events: none;
}

.ico {
  height: 30px;
  pointer-events: none;
  margin-right: 5px;
}

.custom-navbar {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: padding 0.3s ease;
  background-color: #f8f9fa;
}

/* Estilos para pantallas pequeñas */
@media (max-width: 991px) {
  .custom-navbar {
    padding: 8px 16px;
  }
  .navbar-toggler {
    border: none;
    height: 30px;
  }
  navbar-toggler-icon {
    height: 20px;
  }
  .logo {
    height: 30px;
  }

  .ico {
    height: 24px;
  }

  .navbar-nav {
    margin-top: 10px;
  }

  form.d-flex {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
</style>
